// Vendor imports
const React = require('react')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const SearchForm = require('client-v2/common/components/search-form')

const bem = BemEntity('LandingHeader')

class LandingHeader extends React.PureComponent {
  constructor(props) {
    super(props)
    this.searchFormRef = React.createRef()

    this.state = {
      searchVisible: false
    }

    // Bind event listeners to component context
    this.onSearchReset = this.onSearchReset.bind(this)
    this.onSearchShowClick = this.onSearchShowClick.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.searchVisible && !nextProps.isScrolledBelowFold) {
      return { searchVisible: false }
    }
    return null
  }

  onSearchShowClick() {
    this.setState({
      searchVisible: !this.state.searchVisible
    }, () => {
      const searchForm = this.searchFormRef.current
      if (searchForm) {
        if (this.state.searchVisible) {
          searchForm.focus()
        } else {
          searchForm.blur()
        }
      }
    })
  }

  onSearchReset() {
    this.setState({ searchVisible: false })
  }

  renderAuthSection() {
    return (
      tag('div', {
        className: bem.element('auth-section')
      },
        tag('button', {
          className: bem.element('auth-button', 'primary'),
          onClick: (
            this.props.isSULandingPage
              ? this.props.onSULoginClick
              : this.props.onSignupClick
          )
        },
          `Join Mix`
        ),
        tag('button', {
          className: bem.element('auth-button', 'secondary'),
          onClick: this.props.onLoginClick
        },
          `Sign in`
        )
      )
    )
  }

  renderBrandingSection() {
    return (
      tag('div', {
        className: bem.element('branding-section')
      },
        this.renderLogoContainer(),
        this.renderSearchContainer(),
        this.renderSearchButton()
      )
    )
  }

  renderLogoContainer() {
    return (
      tag('div', {
        className: bem.element('logo-container')
      },
        tag('div', {
          className: bem.element('logo-icon')
        }),
        tag('div', {
          className: bem.element('logo-text')
        })
      )
    )
  }

  renderSearchButton() {
    return (
      tag('button', {
        className: bem.element('search-button'),
        onClick: this.onSearchShowClick
      },
        tag('span', { className: 'mdi-action-search' })
      )
    )
  }

  renderSearchContainer() {
    return (
      tag('div', {
        className: bem.element('search-container')
      },
        tag(SearchForm, {
          className: bem.element('search-form'),
          ref: this.searchFormRef,
          // Callbacks
          onNavigate: this.props.onSearchNavigate,
          onReset: this.onSearchReset,
          onSubmit: this.props.onSearchSubmit
        })
      )
    )
  }

  render() {
    return (
      tag('div', {
        className: bem.block({
          'experiment': this.props.experiment,
          'scrolled-to-top': this.props.isScrolledToTop,
          'scrolled': this.props.isScrolledBelowFold ? 'down' : 'up',
          'searching': this.state.searchVisible
        })
      },
        this.renderBrandingSection(),
        this.renderAuthSection()
      )
    )
  }
}

LandingHeader.propTypes = {
  // Flags
  isScrolledToTop: PropTypes.bool.isRequired,
  isScrolledBelowFold: PropTypes.bool.isRequired,
  isSULandingPage: PropTypes.bool.isRequired,
  // Values
  experiment: PropTypes.string,
  // Callbacks
  onLoginClick: PropTypes.func.isRequired,
  onSignupClick: PropTypes.func.isRequired,
  onSULoginClick: PropTypes.func.isRequired,
  onSearchNavigate: PropTypes.func.isRequired,
  onSearchSubmit: PropTypes.func.isRequired
}

module.exports = LandingHeader
